import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectlanguage: 'en',
    apihost: 'https://www.archipelagointernational.com/api/sentech/',
    labels: [],
    configs: [],
    renderpage: true,
    activeLanguage: 1,
    menu: [],
  },
  mutations: {
    savelabel(state, val) {
      state.labels = val
    },
    saveconfig(state, val) {
      state.configs = val
    },
    savemenu(state, val) {
      state.menu = val
    },
    changeLanguage(state, val) {
      state.selectlanguage = val
    },
    switchLanguage(state, val) {
      state.activeLanguage = val
    },
    switchRender(state, val) {
      state.renderpage = val
    },
  },
  actions: {
  },
  modules: {
  }
})
